import { render, staticRenderFns } from "./actor-desired-projects.vue?vue&type=template&id=ef249078&"
import script from "./actor-desired-projects.vue?vue&type=script&lang=ts&"
export * from "./actor-desired-projects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports